;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('filterPermissionsDropdown', filterPermissionsDropdown)

  /* @ngInject */
  function filterPermissionsDropdown () {
    return {
      restrict: 'E',
      scope: {
        params: '=',
        showFilterButton: '<',
        defaultPermissionsList: '<'
      },
      templateUrl: '/core/directives/core-filters/dropdowns/filter-permissions-dropdown/filter-permissions-dropdown-directive.html?$$REVISION$$',
      controller: 'FilterPermissionsDropdownController'
    }
  }
})()
